import { decodeFanslyAudiencePicker, encodeFanslyAudience, fanslyAudiencePickerIds, hasFanslyAudience } from '../MassMessages/fanslyAudience';

export function priorityAudienceToPicker(saved: string[]): string[] {
  const explicit = saved.some((value) => value.startsWith('__fansly_group_flags_'));
  return fanslyAudiencePickerIds(explicit ? saved : ['__fansly_group_flags_0__', ...saved]);
}

export function priorityAudienceFromPicker(selected: string[]): string[] {
  const { flags, listIds } = decodeFanslyAudiencePicker(selected);
  if (flags & (32 | 64)) {
    throw new Error('Fansly creator/offline exclusions cannot be applied to personal priority messages');
  }
  if (!hasFanslyAudience(flags, listIds)) {
    throw new Error('Choose subscribers, expired subscribers, followers, or a user list');
  }
  return encodeFanslyAudience(flags, listIds);
}
